import {
  LAMBDATEST_CAPABILITY_PLATEFORM_LIST_LOADING,
  LAMBDATEST_CAPABILITY_PLATEFORM_LIST_SUCCESS,
  LAMBDATEST_CAPABILITY_PLATEFORM_LIST_FAILED,
  LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_LOADING,
  LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_SUCCESS,
  LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_FAILED,
  LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_LOADING,
  LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_SUCCESS,
  LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_FAILED,
  LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_LOADING,
  LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_SUCCESS,
  LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_FAILED,
  LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_LOADING,
  LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_SUCCESS,
  LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_FAILED,
  LAMBDATEST_CAPABILITY_UPDATE_CAPABILITY_VALUES,
  LAMBDATEST_CAPABILITY_DRIVER_LIST_LOADING,
  LAMBDATEST_CAPABILITY_DRIVER_LIST_SUCCESS,
  LAMBDATEST_CAPABILITY_DRIVER_LIST_FAILED,
  LAMBDATEST_CAPABILITY_RESET_CAPABILITY_VALUES
} from "../actionTypeConstants/LambdaTestCapabilityConstants";

// vasu-lt: remove this constants file in future and refactor this reducer
import { javaCode } from "../../common/javaCode";
import {
  javaCodeBrowserStack,
  javaCodeLambdatest,
  javaCodeSoucelab
} from "../../components/ConfigureOnboardTest/migrationCode/migrationCode";

const initialState = {
  selenium: {
    loading: false,
    data: null,
    error: null,
    plateformBrowser: {
      loading: false,
      data: null,
      error: null
    },
    driverVersions: {
      loading: false,
      data: [],
      error: null
    }
  },
  selenium4: {
    loading: false,
    data: null,
    error: null
  },
  appium: {
    loading: false,
    data: null,
    error: null,
    plateformDevices: {
      loading: false,
      data: null,
      error: null
    },
    appiumVersion: {
      loading: false,
      data: null,
      error: null
    }
  },
  currentCapabilty: {
    grid: "Selenium",
    os: "Windows 10",
    resolution: "1024x768",
    browser: "Chrome",
    browserversion: "109.0",
    osAppium: "android",
    brand: "Samsung",
    deviceAppium: "Galaxy A8",
    osVersionAppium: "7.1",
    language: "java",
    codeToExecute: javaCode,
    platform: "macOS",
    parallelTestCount: 1,
    framework: {
      name: "Java",
      docLink:
        "https://www.lambdatest.com/support/docs/getting-started-with-lambdatest-automation/"
    },
    parallelTest: [
      {
        os: "Windows 10",
        resolution: "1024x768",
        browser: "Chrome",
        browserversion: "109.0"
      },
      {
        os: "Windows 10",
        resolution: "1024x768",
        browser: "Chrome",
        browserversion: "109.0"
      }
    ],
    migrationCodeLT: javaCodeLambdatest,
    migrationCodeBS: javaCodeBrowserStack,
    migrationCodeSL: javaCodeSoucelab,
    migrationCredCodeWindows: "",
    migrationCredCodeLinux: "",
    credentialCodeLT: "",
    credentialCodeBS: "",
    credentialCodeSL: "",
    hubUrlCodeLT: "",
    hubUrlCodeBS: "",
    hubUrlCodeSL: "",
    currentSelenium: "",
    currentDriver: "",
    headless: false,
    popups: false,
    flash: false,
    cookies: false,
    compatibility: "",
    geoLocation: "",
    tunnel: false,
    console: false,
    network: false,
    visual: false,
    video: true,
    timezone: false
  }
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_CAPABILITY_PLATEFORM_LIST_LOADING:
      return {
        ...state,
        selenium: { ...state.selenium, loading: true }
      };

    case LAMBDATEST_CAPABILITY_PLATEFORM_LIST_SUCCESS:
      return {
        ...state,
        selenium: {
          ...state.selenium,
          loading: false,
          data: action.result.data
        }
      };

    case LAMBDATEST_CAPABILITY_PLATEFORM_LIST_FAILED:
      return {
        ...state,
        selenium: {
          ...state.selenium,
          loading: false,
          error: action.error
        }
      };

    case LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_LOADING:
      return {
        ...state,
        selenium: {
          ...state.selenium,
          plateformBrowser: { ...state.plateformBrowser, loading: true }
        }
      };

    case LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_SUCCESS:
      return {
        ...state,
        selenium: {
          ...state.selenium,
          plateformBrowser: {
            ...state.plateformBrowser,
            loading: false,
            data: action.result.data
          }
        }
      };

    case LAMBDATEST_CAPABILITY_PLATEFORM_BROWSERS_LIST_FAILED:
      return {
        ...state,
        selenium: {
          ...state.selenium,
          plateformBrowser: {
            ...state.plateformBrowser,
            loading: false,
            error: action.error
          }
        }
      };

    case LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_LOADING:
      return {
        ...state,
        appium: { ...state.appium, loading: true }
      };

    case LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_SUCCESS:
      return {
        ...state,
        appium: {
          ...state.appium,
          loading: false,
          data: action.result.data
        }
      };

    case LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_LIST_FAILED:
      return {
        ...state,
        appium: {
          ...state.appium,
          loading: false,
          error: action.error
        }
      };

    case LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_LOADING:
      return {
        ...state,
        appium: {
          ...state.appium,
          plateformDevices: { ...state.plateformDevices, loading: true }
        }
      };

    case LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_SUCCESS:
      return {
        ...state,
        appium: {
          ...state.appium,
          plateformDevices: {
            ...state.plateformDevices,
            loading: false,
            data: action.result.data
          }
        }
      };

    case LAMBDATEST_CAPABILITY_APPIUM_PLATEFORM_DEVICE_LIST_FAILED:
      return {
        ...state,
        appium: {
          ...state.appium,
          plateformDevices: {
            ...state.plateformDevices,
            loading: false,
            error: action.error
          }
        }
      };

    case LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_LOADING:
      return {
        ...state,
        appium: {
          ...state.appium,
          appiumVersion: { ...state.appiumVersion, loading: true }
        }
      };

    case LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_SUCCESS:
      return {
        ...state,
        appium: {
          ...state.appium,
          appiumVersion: {
            ...state.appiumVersion,
            loading: false,
            data: action.result.data
          }
        }
      };

    case LAMBDATEST_CAPABILITY_APPIUM_VERSION_LIST_FAILED:
      return {
        ...state,
        appium: {
          ...state.appium,
          appiumVersion: {
            ...state.appiumVersion,
            loading: false,
            error: action.error
          }
        }
      };

    case LAMBDATEST_CAPABILITY_UPDATE_CAPABILITY_VALUES:
      return {
        ...state,
        currentCapabilty: {
          ...state.currentCapabilty,
          ...action.payload
        }
      };
    case LAMBDATEST_CAPABILITY_RESET_CAPABILITY_VALUES:
      return {
        ...state,
        currentCapabilty: {
          ...state.currentCapabilty,
          ...initialState.currentCapabilty
        }
      };
    case LAMBDATEST_CAPABILITY_DRIVER_LIST_LOADING:
      return {
        ...state,
        selenium: {
          ...state.selenium,
          driverVersions: { ...state.driverVersions, loading: true }
        }
      };
    case LAMBDATEST_CAPABILITY_DRIVER_LIST_SUCCESS:
      return {
        ...state,
        selenium: {
          ...state.selenium,
          driverVersions: {
            ...state.driverVersions,
            data: action.result.data,
            loading: false
          }
        }
      };
    case LAMBDATEST_CAPABILITY_DRIVER_LIST_FAILED:
      return {
        ...state,
        selenium: {
          ...state.selenium,
          driverVersions: {
            ...state.driverVersions,
            loading: false,
            error: action.error
          }
        }
      };
    default:
      return state;
  }
}
